import { inject } from "@angular/core";
import { SessionService } from "../services/session.service";
import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // Liste des endpoints à ignorer (ex: login, signup, refresh)
  const excludedUrls = ['/login', '/register'];
  console.log(req.url)

  if(excludedUrls.some(url => req.url.includes(url))) return next(req);

  const session = inject(SessionService);
  const token = session.currentToken;

  if (token) {
    req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
  return next(req);
};